import { IncorporationRequestDataType } from '@commenda/types';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { IncorporationRequestStatus } from '@prisma/client';

export enum MemberControlType {
  personInControl = 'personInControl',
  corporateBodyInControl = 'corporateBodyInControl',
}

export enum UKLocationOptions {
  EnglandAndWales = 'England and Wales',
  NorthernIreland = 'Northern Ireland',
  Scotland = 'Scotland',
  Wales = 'Wales',
}

export enum CompanyBuySellStatus {
  SameDate = 'sameDate',
  DifferentDate = 'differentDate',
  NoSuchDate = 'noSuchDate',
}

export enum UKMailingAddressOptions {
  OptIn = 'opt-in',
  OwnAddress = 'own-address',
}

export enum PrincipalPlaceOfBusinessOptions {
  NoAddress = 'no-address',
  SameAddress = 'same-address',
  DifferentAddress = 'different-address',
}

export enum YesNoOptions {
  Yes = 'yes',
  No = 'no',
}

export const EquityDefaultValues = {
  // This is set to 1 because the most common case in the UK is a wholly-owned subsidiary.
  // Customers who have multiple shareholders should override this manually until we come up with a
  // better product experience.
  shareCount: 1,
  price: 1,
  sharesRetained: 15,
};

export const getPagesFilledForUKForm = (
  data: WorkRequestResponseType & { requestData: IncorporationRequestDataType }
): number => {
  if (!data) return null;

  const corporationDirectors = data?.directors?.filter((dir) =>
    dir.corporationHasDirector?.find(
      (dirWithCorp) => dirWithCorp.corporationId === data.corporationId
    )
  );

  const doesHaveDirector = corporationDirectors?.find((director) =>
    director.corporationHasDirector?.find(
      (dirWithCorp) =>
        dirWithCorp.corporationId === data.corporationId &&
        dirWithCorp.additionalDirectorInformation?.isDirector
    )
  );

  const hasFilingAuthorization = corporationDirectors?.some((director) =>
    director.corporationHasDirector?.find(
      (dirWithCorp) =>
        dirWithCorp.corporationId === data.corporationId &&
        dirWithCorp.additionalDirectorInformation
          ?.isDigitallyAuthorisedToFileOnline !== undefined
    )
  );

  // Check if equity information exists in the corporation data
  const hasEquityInfo =
    data?.corporation?.shareCount !== null &&
    data?.corporation?.shareCount !== undefined;

  // Check if there are any stakeholders/shareholders (alternative way to check)
  const hasStakeholders = corporationDirectors?.length > 0;

  if (
    data &&
    data.status !== IncorporationRequestStatus.NotStarted &&
    data.status !== IncorporationRequestStatus.InProgress
  ) {
    return 4;
  }

  if (
    hasEquityInfo &&
    hasFilingAuthorization &&
    doesHaveDirector &&
    hasStakeholders
  ) {
    return 4;
  }

  if (hasFilingAuthorization && doesHaveDirector && hasStakeholders) {
    return 3;
  }

  if (doesHaveDirector && hasStakeholders) {
    return 2;
  }

  if (doesHaveDirector || hasStakeholders) {
    return 1;
  }

  if (data?.requestData?.companyLegalName) {
    return 0;
  }

  return null;
};
